import {
  USER_PROFILE_SERVICE_COOKIE_NAME,
  USER_PROFILE_SERVICE_ORIGIN_HASH_COOKIE_NAME,
} from '../constants';
import { CookieUtils } from '../types/cookies_utils';
import Identifier from './identifiers';

class UserProfileService {
  constructor(
    private readonly identifier: Identifier,
    private readonly cookieUtils: CookieUtils,
  ) {}

  getUserProfileServiceId() {
    // This does nothing if valid UPS cookie has been set already
    this.identifier.authorizeIdentifier(USER_PROFILE_SERVICE_COOKIE_NAME);

    return this.cookieUtils.getCookie(USER_PROFILE_SERVICE_COOKIE_NAME);
  }

  getUserProfileServiceIdOriginHash() {
    const cookie = this.cookieUtils.getCookie(USER_PROFILE_SERVICE_ORIGIN_HASH_COOKIE_NAME);

    return cookie && decodeURIComponent(cookie);
  }

  checkResetUserProfileServiceId(userId: string) {
    return this.identifier.checkResetIdentifier(
      userId,
      USER_PROFILE_SERVICE_ORIGIN_HASH_COOKIE_NAME,
      USER_PROFILE_SERVICE_COOKIE_NAME,
    );
  }
}

export default UserProfileService;
